import { trace } from "@nopeer";

// 🎯 복잡한 상속을 지우고 팝업 고유의 역할(껍데기 조립)만 수행합니다.
export class NinePopup extends HTMLElement {
	static get tagName() { return "nine-popup"; }

	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		// 🔒 Shadow DOM 내부에 nine-dialog 레이아웃 구축
		this.shadowRoot.innerHTML = `
			<nine-dialog>
				<div class="popup-body"></div>
			</nine-dialog>
		`;
	}

	close(returnValue = null) {
		const $dialog = this.dialog;
		if ($dialog) {
			// 🎯 구질구질한 커스텀 이벤트 대신, 기존 자산인 다이얼로그의 애니메이션 종료 함수를 직접 타격합니다.
			$dialog.closeWithAnimation(returnValue);
		}
	}

	// 🔓 리액트 엔진이 꽂아 넣을 입구 포인터 개방
	get popupBody() {
		return this.shadowRoot?.querySelector('nine-dialog .popup-body') || null;
	}

	// 🔓 리액트나 외부 유틸에서 직접 제어할 수 있는 제어 통로
	get dialog() {
		return this.shadowRoot?.querySelector('nine-dialog') || null;
	}
}

if (!customElements.get('nine-popup')) customElements.define('nine-popup', NinePopup);